import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus, Eye, Download } from 'lucide-react';

export const HeroHeader = () => {
  const quickActions = [
    {
      label: 'Nueva Publicación',
      href: '/publicaciones/nueva',
      icon: Plus,
      variant: 'default',
      testId: 'dashboard-new-listing-button'
    },
    {
      label: 'Ver Ofertas',
      href: '/ofertas',
      icon: Eye,
      variant: 'outline',
      testId: 'dashboard-view-offers-button'
    },
    {
      label: 'Reportes',
      href: '/reportes',
      icon: Download,
      variant: 'outline',
      testId: 'dashboard-reports-button'
    },
  ];

  return (
    <div className="bg-card/50 border-b border-border py-8 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground">
              Dashboard de Análisis
            </h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Monitoreo en tiempo real de operaciones
            </p>
          </div>
          <div className="hidden md:flex items-center gap-3">
            {quickActions.slice(0, 2).map((action) => {
              const Icon = action.icon;
              return (
                <Button
                  key={action.label}
                  asChild
                  size="sm"
                  className="bg-primary/10 hover:bg-primary/20 text-primary border border-primary/20"
                >
                  <Link to={action.href}>
                    <Icon className="h-4 w-4 mr-2" />
                    {action.label}
                  </Link>
                </Button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
